import { getEnvVar } from 'src/lib/env'

export const COLUMN_LABELS = {
  ADDITIONAL_BATHROOMS: 'Additional Bathrooms',
  ADDITIONAL_FEATURES: 'Additional Features',
  ADDITIONAL_PLAN: 'Additional Plan Attributes',
  ADDITIONAL_ROOMS: 'Additional Rooms',
  APPROVAL_STATUS: 'Approval Status',
  ARCHITECTURAL_SHAKE: 'Architectural Shake',
  ARCHITECTURAL_SHINGLE: 'Architectural Shingle',
  ARCHITECTURE_FIRM: 'Architecture Firm',
  BASE_HOUSE_PRE: 'Base House Pre',
  BASE_HOUSE_PRICE: 'Base House Price',
  BASE_PLAN: 'Base Plan',
  BASEMENT: 'Basement',
  BASEMENT_SQ_FT: 'Basement Sq Ft',
  BASEMENT_TYPE: 'Basement Type',
  BEDROOMS: 'Bedrooms',
  BOARD_AND_BATTEN: 'Board and Batten',
  BONUS_ROOM: 'Bonus Room',
  BONUS_ROOM_LIVING_SPACE_IMPACTS: 'Bonus Room Living Space Impacts',
  BONUS_ROOM_LOCATION: 'Bonus Room Location',
  BONUS_ROOM_SQ_FT: 'Bonus Room Sq Ft',
  BOX_FILE: 'Box File',
  COMMUNITY_NAME: 'Community Name',
  COMMUNITY_NUMBER: 'Community Number',
  COMMUNITY_NUMBER_OR_REGION: 'Community Number or Region',
  COPY_APPROVAL: 'Copy Approval',
  CORE_PLAN: 'Core Plan',
  CREATED_BY: 'Created By',
  CREATED_ON: 'Created On',
  CUSTOMER_SEGMENT: 'Customer Segment',
  DECK: 'Deck',
  DECK_SIZE_SQ_FT: 'Deck Size • Sq Ft',
  DEPTH_FT: 'Depth of the Plan Ft',
  DEPTH_IN: 'Depth Of Plan In.',
  DEPTH_OF_PLAN: 'Depth Of Plan',
  DERIVED_FROM_APPROVED_REGIONAL_PLAN: 'Derived from Regional Plan',
  DERIVED_FROM_CORE: 'Derived From Core',
  DIVISION: 'Division',
  DOCUMENTS: 'Documents',
  EFFECTIVE_DATE: 'Effective Date',
  EIGHTH_FLOOR_CEILING_HEIGHT: '8th Floor Ceiling Height',
  EIGHTH_FLOOR_SQ_FT: '8th Floor Sq Ft',
  ENGINEER_NAME: 'Engineer Name',
  ENGINEER_OF_RECORD: 'Engineer of Record',
  ENTRY: 'Entry',
  ENTRY_SIZE_SQ_FT: 'Entry Size • Sq Ft',
  EXTERIOR_CLADDING: 'Exterior Cladding',
  EXTERIOR_WALL_CONSTRUCTION: 'Exterior Wall Construction',
  FAMILY_ROOM: 'Family Room',
  FAMILY_ROOM_LIVING_SPACE_IMPACTS: 'Family Room Living Space Impacts',
  FAMILY_ROOM_LOCATION: 'Family Room Location',
  FAMILY_ROOM_SQ_FT: 'Family Room Sq Ft',
  FEET: 'Ft',
  FIFTH_FLOOR_CEILING_HEIGHT: '5th Floor Ceiling Height',
  FIFTH_FLOOR_SQ_FT: '5th Floor Sq Ft',
  FIRM_NAME: 'Architecture Firm Name',
  FIRST_FLOOR_CEILING_HEIGHT: '1st Floor Ceiling Height',
  FIRST_FLOOR_SQ_FT: '1st Floor Sq Ft',
  FLEX: 'Flex',
  FLEX_LIVING_SPACE_IMPACTS: 'Flex Living Space Impacts',
  FLEX_LOCATION: 'Flex Location',
  FLEX_SQ_FT: 'Flex Sq Ft',
  FLOOR: 'Floor',
  FLOOR_CEILING_HEIGHT: 'Floor Ceiling Height',
  FLOOR_SQ_FT: 'Floor Sq Ft',
  FORMAL_DINING_ROOM: 'Formal Dining Room',
  FORMAL_LIVING_ROOM: 'Formal Living Room',
  FOUNDATION_TYPE: 'Foundation Type',
  FOURTH_FLOOR_CEILING_HEIGHT: '4th Floor Ceiling Height',
  FOURTH_FLOOR_SQ_FT: '4th Floor Sq Ft',
  FULL_BATHROOMS: 'Full Bathrooms',
  GAME_ROOM: 'Game Room',
  GAME_ROOM_LIVING_SPACE_IMPACTS: 'Game Room Living Space Impacts',
  GAME_ROOM_LOCATION: 'Game Room Location',
  GAME_ROOM_SQ_FT: 'Game Room Sq Ft',
  GARAGE_ALIGNMENT: 'Garage Alignment',
  GARAGE_ATT_DET: 'Garage Att/Det',
  GARAGE_LOAD: 'Garage Load',
  GARAGE_SIZE: 'Garage Size',
  GARAGE_SIZE_2: 'Garage Size 2',
  GARAGE_SIZE_SQ_FT: 'Garage Size • Sq Ft',
  GARAGE_TYPE: 'Garage Type',
  GOLF_CART_GARAGE: 'Golf Cart Garage',
  GOLF_CART_GARAGE_ATT_DET: 'Golf Cart Garage Att/Det',
  GOLF_CART_GARAGE_SIZE: 'Golf Cart Garage Size',
  GOLF_CART_GARAGE_SIZE_SQ_FT: 'Golf Cart Garage Size • Sq Ft',
  GREAT_ROOM: 'Great Room',
  GREAT_ROOM_LIVING_SPACE_IMPACTS: 'Great Room Living Space Impacts',
  GREAT_ROOM_LOCATION: 'Great Room Location',
  GREAT_ROOM_SQ_FT: 'Great Room Sq Ft',
  HALF_BATHROOMS: 'Half Bathrooms',
  HIDDEN: 'Hidden',
  HIERARCHY: 'Hierarchy',
  IMAGES: 'Images',
  IMPACT_WINDOWS: 'Impact Windows',
  INCH: 'In',
  INDOOR_FIREPLACE: 'Indoor Fireplaces',
  INTERIOR_SPRINKLERS: 'Interior Sprinklers',
  INTERIOR_WALL_CONSTRUCTION: 'Interior Wall Construction',
  IS_SYNCED_WITH_JDE: 'Synced with JDE',
  LANAI: 'Lanai',
  LANAI_ENCLOSURES: 'Lanai/Enclosures',
  LANAI_SQ_FT: 'Lanai/Enclosures Size • Sq Ft',
  LANAI_TYPE: 'Lanai Type',
  LENNAR_URL: 'Lennar.com link',
  LIVING_AREAS: 'Number of Living Areas',
  LIVING_SPACE_IMPACTS: 'Living Space Impacts',
  LOFT: 'Loft',
  LOFT_LIVING_SPACE_IMPACTS: 'Loft Living Space Impacts',
  LOFT_LOCATION: 'Loft Location',
  LOFT_SQ_FT: 'Loft Sq Ft',
  MARKETING_MATERIALS: 'Marketing Materials',
  MARKETING_NAME: 'Marketing Name',
  MATERIAL_ROOF_TYPE: 'Material Roof Type',
  MENU: 'Menu',
  MODIFIED_ON: 'Modified On',
  NINTH_FLOOR_CEILING_HEIGHT: '9th Floor Ceiling Height',
  NINTH_FLOOR_SQ_FT: '9th Floor Sq Ft',
  NUMBER_OF_CARS_GARAGES: 'Number of Cars/Garages',
  NUMBER_OF_CARS_GARAGES_2: 'Number of Cars/Garages 2',
  NUMBER_OF_DINING_AREAS: 'Number of Dining Areas',
  NUMBER_OF_FIXTURES: 'Number Of Fixtures',
  NUMBER_OF_INDOOR_FIREPLACES: 'No. of Indoor Fireplaces',
  NUMBER_OF_OUTDOOR_FIREPLACES: 'No. of Outdoor Fireplaces',
  OPTIONAL: ' • Optional',
  OPTIONAL_GARAGE: 'Optional Garage',
  OPTIONAL_GARAGE_ATT_DET: 'Optional Garage Att/Det',
  OPTIONAL_GARAGE_NUMBER_OF_CAR_GARAGES:
    'Optional Garage Number of Cars/Garages',
  OPTIONAL_GARAGE_SIZE: 'Optional Garage Size',
  OPTIONAL_GARAGE_SIZE_SQ_FT: 'Optional Garage Size • Sq Ft',
  OUTDOOR_FIREPLACE: 'Outdoor Fireplaces',
  OUTDOOR_KITCHEN: 'Outdoor Kitchen',
  OWNERS_SUITE_LOCATION: 'Owners Suite Location',
  PARENT_PLAN: 'Parent Plan',
  PATIO: 'Patio',
  PATIO_SIZE_SQ_FT: 'Patio Size • Sq Ft',
  PATIO_TYPE: 'Patio Type',
  PLAN: 'Plan',
  PLAN_CATEGORY: 'Plan Category',
  PLAN_CEILING_HEIGHT: 'Plan Ceiling Height',
  PLAN_CHANGE_NUMBER: 'Plan Change Number',
  PLAN_ELEVATION: 'Plan Elevation',
  PLAN_MASTER_DATA: 'Plan Master Data',
  PLAN_NAME: 'Name',
  PLAN_NAME_EXPORT: 'Plan Name',
  PLAN_OVERVIEW: 'Plan Overview',
  PLAN_OWNED_BY_LENNAR: 'Plan Owned by Lennar',
  PLAN_STATUS: 'Plan Status',
  PLAN_STRUCTURE: 'Plan Structure',
  PLAN_TYPE: 'Plan Type',
  REGION: 'Region',
  REGIONAL_PLAN_APPROVAL_STATUS: 'Regional Plan Approval',
  REVIEW: 'Review',
  ROOF_SHAPE: 'Roof Shape',
  RV_GARAGE: 'RV Garage',
  RV_GARAGE_ATT_DET: 'RV Garage Att/Det',
  RV_GARAGE_SIZE: 'RV Garage Size',
  RV_GARAGE_SIZE_SQ_FT: 'RV Garage Size • Sq Ft',
  SECOND_FLOOR_CEILING_HEIGHT: '2nd Floor Ceiling Height',
  SECOND_FLOOR_SQ_FT: '2nd Floor Sq Ft',
  SERIES: 'Series',
  SEVENTH_FLOOR_CEILING_HEIGHT: '7th Floor Ceiling Height',
  SEVENTH_FLOOR_SQ_FT: '7th Floor Sq Ft',
  SHARED_BY: 'Shared By',
  SIDING_LAP: 'Siding Lap',
  SIDING_PANEL: 'Siding Panel',
  SIXTH_FLOOR_CEILING_HEIGHT: '6th Floor Ceiling Height',
  SIXTH_FLOOR_SQ_FT: '6th Floor Sq Ft',
  SPECIFICATIONS: 'Specifications',
  SQFT_OF_HOME_CONDITIONED_SPACE: 'Conditioned Space Sq Ft',
  STORIES: 'Stories',
  STORM_SHUTTERS: 'Storm Shutters',
  STRUCTURE_TYPE: 'Structure Type',
  STUDY: 'Study',
  STUDY_LIVING_SPACE_IMPACTS: 'Study Living Space Impacts',
  STUDY_LOCATION: 'Study Location',
  STUDY_SQ_FT: 'Study Sq Ft',
  SUN_ROOM: 'Sun Room',
  SUN_ROOM_LIVING_SPACE_IMPACTS: 'Sun Room Living Space Impacts',
  SUN_ROOM_LOCATION: 'Sun Room Location',
  SUN_ROOM_SQ_FT: 'Sun Room Sq Ft',
  SUPPLEMENTAL_SPECS_DOCS: 'Supplemental Specs/Docs',
  TARGET_PROFIT: 'Target Profit Percentage',
  THIRD_FLOOR_CEILING_HEIGHT: '3rd Floor Ceiling Height',
  THIRD_FLOOR_SQ_FT: '3rd Floor Sq Ft',
  TOTAL_HOME_SQ_FT: 'Total Home Sq Ft',
  UNDER_ROOF_SQ_FT: 'Under Roof Sq Ft',
  VALUE_ENGINEERED: 'Value Engineered',
  VAULTED_CEILING: 'Vaulted Ceiling',
  VAULTED_CEILING_LIVING_SPACE_IMPACTS: 'Vaulted Ceiling Living Space Impacts',
  VAULTED_CEILING_LOCATION: 'Vaulted Ceiling Location',
  VIRTUAL_TOURS: 'Virtual Tours',
  WIDTH_FT: 'Width of the Plan Ft',
  WIDTH_IN: 'Width Of Plan In.',
  WIDTH_OF_PLAN: 'Width Of Plan',
  YEAR_OF_CREATION: 'Year of Creation',
}

export const OPTIONAL = ' • Optional'

export const SHELL_COLUMN_LABELS = {
  ARCHITECTURAL_SHAKE: 'Architectural Shake',
  ARCHITECTURAL_SHINGLE: 'Architectural Shingle',
  BOARD_AND_BATTEN: 'Board and Batten',
  BUILDING_SQ_FT: 'Building Living Sq Ft.',
  BUILDING_UNDER_ROOF_SQ_FT: 'Building Total Under Roof Sq Ft.',
  CLASS: 'Class',
  COMMUNITY_NUMBER_OR_REGION: 'Community Number or Region',
  DEPTH_BUILDING_FT: 'Depth of the Building Ft.',
  DEPTH_BUILDING_IN: 'Depth Of Building In.',
  DEPTH_OF_THE_BUILDING: 'Depth of the Building',
  DEPTH_OF_THE_UNITS: 'Depth of the Units',
  DEPTH_UNIT_FT: 'Depth of the Unit Ft.',
  DEPTH_UNIT_IN: 'Depth Of Unit In.',
  EXTERIOR_CLADDING: 'Exterior Cladding',
  EXTERIOR_WALL_CONSTRUCTION: 'Exterior Wall Construction',
  FOUNDATION_TYPE: 'Foundation Type',
  GARAGE_ATT_DET: 'Garage Att/Det',
  GARAGE_LOAD: 'Garage Load',
  GARAGE_SIZE: 'Garage Size',
  GARAGE_SIZE_2: 'Garage Size 2',
  GARAGE_SIZE_SQ_FT: 'Garage Size • Sq Ft.',
  INTERIOR_WALL_CONSTRUCTION: 'Interior Wall Construction • Optional',
  MARKETING_NAME: 'Marketing Name',
  NUMBER_OF_CARS_GARAGES: 'Number of Cars/Garages',
  NUMBER_OF_CARS_GARAGES_2: 'Number of Cars/Garages 2',
  SHELL_ELEVATION: 'Shell Elevation',
  SHELL_STATUS: 'Shell Status',
  SHELL_TYPE: 'Shell Type',
  SIDING_LAP: 'Siding Lap',
  SIDING_PANEL: 'Siding Panel',
  STORIES: 'Stories',
  UNITS: 'Units',
  WIDTH_BUILDING_FT: 'Width of the Building Ft.',
  WIDTH_BUILDING_IN: 'Width Of Building In.',
  WIDTH_OF_THE_BUILDING: 'Width of the Building',
  WIDTH_OF_THE_UNITS: 'Width of the Units',
  WIDTH_UNIT_FT: 'Width of the Unit Ft.',
  WIDTH_UNIT_IN: 'Width Of Unit In.',
  YEAR_OF_CREATION: 'Year of Creation',
}

export const UNIT_COLUMN_LABELS = {
  ARCHITECTURE_FIRM: 'Architecture Firm',
  BASE_UNIT_PRE: 'Base Unit Pre',
  BASE_UNIT_PRICE: 'Base Unit Price',
  BASEMENT: 'Basement',
  BASEMENT_SQ_FT: 'Basement Sq Ft',
  BASEMENT_TYPE: 'Basement Type',
  BEDROOMS: 'Bedrooms',
  BONUS_ROOM: 'Bonus Room',
  BONUS_ROOM_LIVING_SPACE_IMPACTS: 'Bonus Room Living Space Impacts',
  BONUS_ROOM_LOCATION: 'Bonus Room Location',
  BONUS_ROOM_SQ_FT: 'Bonus Room Sq Ft',
  BUILDING_SQ_FT: 'Building Sq Ft.',
  CLASS: 'Class',
  COMMUNITY_NAME: 'Community Name',
  COMMUNITY_NUMBER: 'Community Number',
  COMMUNITY_NUMBER_OR_REGION: 'Community Number or Region',
  DECK: 'Deck',
  DECK_SIZE_SQ_FT: 'Deck Size • Sq Ft',
  DEPTH_OF_THE_UNIT: 'Depth of the Unit',
  DEPTH_UNIT_FT: 'Depth of the Unit Ft.',
  DEPTH_UNIT_IN: 'Depth Of Unit In.',
  DERIVED_FROM_CORE: 'Derived From Core',
  DIVISION: 'Division',
  EFFECTIVE_DATE: 'Effective Date',
  EIGHTH_FLOOR_SQ_FT: '8th Floor Sq Ft',
  ENGINEER_NAME: 'Engineer Name',
  ENTRY: 'Entry',
  ENTRY_SIZE_SQ_FT: 'Entry Size • Sq Ft',
  EXTERIOR_WALL_CONSTRUCTION: 'Exterior Wall Construction',
  FAMILY_ROOM: 'Family Room',
  FAMILY_ROOM_LIVING_SPACE_IMPACTS: 'Family Room Living Space Impacts',
  FAMILY_ROOM_LOCATION: 'Family Room Location',
  FAMILY_ROOM_SQ_FT: 'Family Room Sq Ft',
  FIFTH_FLOOR_SQ_FT: '5th Floor Sq Ft',
  FIRST_FLOOR_SQ_FT: '1st Floor Sq Ft',
  FLEX: 'Flex',
  FLEX_LIVING_SPACE_IMPACTS: 'Flex Living Space Impacts',
  FLEX_LOCATION: 'Flex Location',
  FLEX_SQ_FT: 'Flex Sq Ft',
  FLOOR: 'Floor',
  FORMAL_DINING_ROOM: 'Formal Dining Room',
  FORMAL_LIVING_ROOM: 'Formal Living Room',
  FOUNDATION_TYPE: 'Foundation Type',
  FOURTH_FLOOR_SQ_FT: '4th Floor Sq Ft',
  FULL_BATHROOMS: 'Full Bathrooms',
  GAME_ROOM: 'Game Room',
  GAME_ROOM_LIVING_SPACE_IMPACTS: 'Game Room Living Space Impacts',
  GAME_ROOM_LOCATION: 'Game Room Location',
  GAME_ROOM_SQ_FT: 'Game Room Sq Ft',
  GARAGE_ATT_DET: 'Garage Att/Det',
  GARAGE_LOAD: 'Garage Load',
  GARAGE_SIZE: 'Garage Size',
  GARAGE_SIZE_2: 'Garage Size 2',
  GARAGE_SIZE_SQ_FT: 'Garage Size • Sq Ft.',
  GREAT_ROOM: 'Great Room',
  GREAT_ROOM_LIVING_SPACE_IMPACTS: 'Great Room Living Space Impacts',
  GREAT_ROOM_LOCATION: 'Great Room Location',
  GREAT_ROOM_SQ_FT: 'Great Room Sq Ft',
  HALF_BATHROOMS: 'Half Bathrooms',
  IMPACT_WINDOWS: 'Impact Windows',
  INDOOR_FIREPLACE: 'Indoor Fireplaces',
  INTERIOR_SPRINKLERS: 'Interior Sprinklers',
  INTERIOR_WALL_CONSTRUCTION: 'Interior Wall Construction • Optional',
  LANAI: 'Lanai/Enclosures',
  LANAI_SQ_FT: 'Lanai/Enclosures Size • Sq Ft',
  LANAI_TYPE: 'Lanai Type',
  LIVING_AREAS: 'Number of Living Areas',
  LIVING_SPACE_IMPACTS: 'Living Space Impacts',
  LOFT: 'Loft',
  LOFT_LIVING_SPACE_IMPACTS: 'Loft Living Space Impacts',
  LOFT_LOCATION: 'Loft Location',
  LOFT_SQ_FT: 'Loft Sq Ft',
  MARKETING_NAME: 'Marketing Name',
  MASTER_BEDROOM_LOCATION: 'Master Bedroom Location',
  NINTH_FLOOR_SQ_FT: '9th Floor Sq Ft',
  NUMBER_OF_CARS_GARAGES: 'Number of Cars/Garages',
  NUMBER_OF_CARS_GARAGES_2: 'Number of Cars/Garages 2',
  NUMBER_OF_DINING_AREAS: 'Number of Dining Areas',
  NUMBER_OF_FIXTURES: 'Number Of Fixtures',
  NUMBER_OF_INDOOR_FIREPLACES: 'No. of Indoor Fireplaces',
  NUMBER_OF_LIVING_AREAS: 'Number of Living Areas',
  NUMBER_OF_OUTDOOR_FIREPLACES: 'No. of Outdoor Fireplaces',
  OUTDOOR_FIREPLACE: 'Outdoor Fireplaces',
  OUTDOOR_KITCHEN: 'Outdoor Kitchen',
  OWNERS_SUITE_LOCATION: 'Owners Suite Location',
  PATIO: 'Patio',
  PATIO_SIZE_SQ_FT: 'Patio Size • Sq Ft',
  PATIO_TYPE: 'Patio Type',
  SECOND_FLOOR_SQ_FT: '2nd Floor Sq Ft',
  SERIES: 'Series',
  SEVENTH_FLOOR_SQ_FT: '7th Floor Sq Ft',
  SIXTH_FLOOR_SQ_FT: '6th Floor Sq Ft',
  SQFT_OF_UNIT_CONDITIONED_SPACE: 'Unit Conditioned Space Sq Ft',
  SQFT_OF_UNIT_UNDER_ROOF: 'Unit Under Roof Sq Ft',
  STORIES: 'Stories',
  STORM_SHUTTERS: 'Storm Shutters',
  STUDY: 'Study',
  STUDY_LIVING_SPACE_IMPACTS: 'Study Living Space Impacts',
  STUDY_LOCATION: 'Study Location',
  STUDY_SQ_FT: 'Study Sq Ft',
  SUN_ROOM: 'Sun Room',
  SUN_ROOM_LIVING_SPACE_IMPACTS: 'Sun Room Living Space Impacts',
  SUN_ROOM_LOCATION: 'Sun Room Location',
  SUN_ROOM_SQ_FT: 'Sun Room Sq Ft',
  THIRD_FLOOR_SQ_FT: '3rd Floor Sq Ft',
  TOTAL_UNIT_SQ_FT: 'Total Unit Sq Ft',
  UNDER_ROOF_SQ_FT: 'Under Roof Sq Ft.',
  UNIT_CHANGE_NUMBER: 'Unit Change Number',
  UNIT_DEPTH_FEET: 'Unit Depth Feet',
  UNIT_DEPTH_INCH: 'Unit Depth Inch',
  UNIT_ELEVATION: 'Unit Elevation',
  UNIT_OWNED_BY_LENNAR: 'Unit Owned by Lennar',
  UNIT_SQ_FT: 'Unit Sq Ft',
  UNIT_STATUS: 'Unit Status',
  UNIT_TYPE: 'Unit Type',
  UNIT_WIDTH_FEET: 'Unit Width Feet',
  UNIT_WIDTH_INCH: 'Unit Width Inch',
  VALUE_ENGINEERED: 'Value Engineered',
  VAULTED_CEILING: 'Vaulted Ceiling',
  VAULTED_CEILING_LIVING_SPACE_IMPACTS: 'Vaulted Ceiling Living Space Impacts',
  VAULTED_CEILING_LOCATION: 'Vaulted Ceiling Location',
  WIDTH_OF_THE_UNIT: 'Width of the Unit',
  WIDTH_UNIT_FT: 'Width of the Unit Ft.',
  WIDTH_UNIT_IN: 'Width Of Unit In.',
  YEAR_OF_CREATION: 'Year of Creation',
}

export enum SupplementalDocumentsTableListColumns {
  ACTIONS = 'Actions',
  COMMUNITY = 'Community',
  DIVISION = 'Division',
  ELEVATION = 'Elevation',
  FILE_SIZE = 'File Size',
  FLOOR = 'Floor',
  IMAGE_REVERSED = 'Image Reversed',
  TIME_UPLOADED = 'Time Uploaded',
  TITLE = 'Title',
  VERSIONS = 'Versions',
}

export enum SupplementalDocumentsFileActionTooltips {
  DELETE = 'Delete',
  DOWNLOAD = 'Download',
  RENAME = 'Rename',
  VIEW = 'View',
}

export const yesNo: Record<string, string> = {
  '': '',
  false: 'No',
  N: 'No',
  true: 'Yes',
  Y: 'Yes',
}
export const planModal = {
  ADD_ELEVATION: 'elevation',
  ADD_ELEVATION_TITLE_TEXT: 'Enter Elevation to get started.',
  ADD_MORE: '+ Add More',
  BYPASS_CORE_PLAN_VALIDATION_LABEL:
    'Plan(s) being entered specific to the Division?',
  CANCEL: 'Cancel',
  COPY_EXISTING_PLAN: 'Copy Existing Plan',
  COPY_INTO_CORE_PLAN_DISABLED:
    "Core plan can't be derived from a Community plan.",
  CREATE_NEW_ELEVATION: 'Create New Elevation',
  CREATE_NEW_MULTI_FAMILY_PLAN: 'Create New Multi-Family Plan',
  CREATE_NEW_PLAN: 'Create New Plan',
  CREATE_NEW_SINGLE_FAMILY_PLAN: 'Create New Single-Family Plan',
  CREATE_PLAN_COMMUNITY_TITLE_TEXT:
    'Enter the Plan Number, Elevation & Community Number to get started.',
  CREATE_PLAN_CORE_TITLE_TEXT:
    'Enter the Plan Number, Elevation & Region to get started.',
  CREATE_PLAN_HIGH_VALUE_TITLE_TEXT:
    'Enter the Plan Number, Elevation & Division to get started.',
  ELEVATIONS_FORMAT_UNIT_TEXT:
    'Last character for elevation(s) for unit family type should be either I or E',
  GRID_ITEM_MARGIN: 0.08,
  MAXIMUM_LENGTH_OF_COMMUNITY: 11,
  MAXIMUM_NUMBER_OF_COLUMNS_IN_GRID: 12,
  MAXIMUM_NUMBER_OF_COMMUNITIES: 5,
  MAXIMUM_NUMBER_OF_PLAN_ELEVATIONS: 10,
  MAXIMUM_NUMBER_OF_PLAN_ELEVATIONS_IN_STEP: 5,
  MAXIMUM_WIDTH_OF_ITEM_IN_GRID: 2.4,
  MINIMUM_COMMUNITIES: 1,
  PLAN_ALREADY_EXIST: 'These plans already exist:',
  PLAN_COPY: 'copy',
  PLAN_CREATE: 'create',
  PLAN_EXISTS_CHECK_FAILED:
    'We could not confirm whether this plan already exists. Please try again.',
  PLAN_HIDDEN_BY_ADMIN: 'Plan has been hidden by an admin user',
  PLAN_PRE_POPULATE: 'pre-populate',
  PRE_POPULATE_EXISTING_PLAN: 'Pre-Populate Plan',
  PROCEED: 'Proceed',
  REPLACE_DOCUMENT: 'Replace Document',
  UNABLE_TO_FETCH_PLAN_NAMES:
    'Something went wrong. One or more of your plans already exist.',
  UNIQUE_COMMUNITIES_TEXT: 'All Communities should be unique!',
  UNIQUE_ELEVATIONS_TEXT: 'All Elevations should be unique!',
  UPLOAD_DOCUMENT: 'Upload Document',
  VALIDATION_COMMUNITY_NUMBER_DIVISION_MISMATCH:
    'Community does not belong to your division! <br /> Please choose a different community.',
  VALIDATION_COMMUNITY_NUMBER_FORMAT:
    'Community Number can be of 9, 10 or 11 digits only',
  VALIDATION_ELEVATION_CHAR_LENGTH_FOR_MULTI_FAMILY_CORE_PLANS:
    'Elevation(s) should be 2 or 3 characters',
  VALIDATION_ELEVATION_CHAR_LENGTH_FOR_MULTI_FAMILY_NON_CORE_PLANS:
    'Elevation(s) should be 1 to 3 characters',
  VALIDATION_ELEVATION_CHAR_LENGTH_FOR_SINGLE_FAMILY:
    'Elevation(s) should be 1 to 3 characters',
  VALIDATION_MSG_DIVISION_SELECTION: 'Please select a division',
  VALIDATION_MSG_REGION_SELECTION: 'Please select a region',
  VALIDATION_NO_COMMUNITY_IN_JDE:
    'There is no community name matched against this community number in JDE, please try again...',
  VALIDATION_PLAN_NUMBER: 'Plan Name should be 4 alphanumeric characters',
  VALIDATION_PLAN_NUMBER_FOR_SHELL_PLANS:
    'Plan Name should be 3 or 4 alphanumeric characters',
  VALIDATION_PLAN_NUMBER_FOR_UNIT_PLANS:
    'Plan Name should be 4 alphanumeric characters',
}

export const livingSpaceImpacts = {
  optional: 'Optional',
  standard: 'Standard',
}

export const TEXAS_DIVISIONS = (
  getEnvVar('TEXAS_DIVISIONS') || 'AUS,HOU,DFW,SAN'
)
  .split(',')
  .map((item) => item?.trim()?.toLowerCase())

export const TEXAS_DIVISIONS_LABELS = (
  getEnvVar('TEXAS_DIVISIONS_LABELS') ||
  'Austin,Houston Lennar,Dallas-Fort Worth,San Antonio'
)
  .split(',')
  .map((item) => item?.trim()?.toLowerCase())

export const floorLabels = [
  COLUMN_LABELS.FIRST_FLOOR_SQ_FT,
  COLUMN_LABELS.SECOND_FLOOR_SQ_FT,
  COLUMN_LABELS.THIRD_FLOOR_SQ_FT,
  COLUMN_LABELS.FOURTH_FLOOR_SQ_FT,
  COLUMN_LABELS.FIFTH_FLOOR_SQ_FT,
  COLUMN_LABELS.SIXTH_FLOOR_SQ_FT,
  COLUMN_LABELS.SEVENTH_FLOOR_SQ_FT,
  COLUMN_LABELS.EIGHTH_FLOOR_SQ_FT,
  COLUMN_LABELS.NINTH_FLOOR_SQ_FT,
]

export const SECTION_TITLES = {
  ADDITIONAL_ATTRIBUTES: 'Additional Attributes',
  ADDITIONAL_ROOMS: 'Additional Rooms',
}

export const MULTI_FAMILY_PLAN_ELEVATION_ERROR = {
  INVALID_LENGTH: 'invalid length',
}

export const MULTI_FAMILY_SHELL_CREATION_DEFAULT_VALUES = {
  SHELL_MASTER_SHELL_AREA: 'Shell Area',
  SHELL_MASTER_SHELL_OVERVIEW: 'Shell Overview',
  SHELL_MASTER_SHELL_STRUCTURE: 'Shell Structure',
  SHELL_SPECIFICATION_GARAGE: 'Garage',
  SHELL_SPECIFICATION_SHELL_SIZE: 'Shell Size',
  SHELL_SPECIFICATION_STRUCTURAL_SPECIFICATIONS: 'Structural Specifications',

  SHELL_STATUS_VALUE:
    'Shell Component of Multi-Fam Do not track to Sale or Web default',
}

export const UNIT_INTAKE_CONSTANTS = {
  UNIT_ADDITIONAL_ATTRIBUTES: 'Additional Attributes',
  UNIT_ADDITIONAL_FEATURES: 'Additional Features',
  UNIT_ADDITIONAL_ROOMS: 'Additional Rooms',
  UNIT_AREA: 'Unit Area',
  UNIT_DINING: 'Dining',
  UNIT_GARAGE: 'Garage',
  UNIT_OVERVIEW: 'Unit Overview',
  UNIT_PRICE: 'Unit Price',
  UNIT_SIZE: 'Unit Size',
  UNIT_STRUCTURAL_SPECIFICATIONS: 'Structural Specifications',
  UNIT_STRUCTURE: 'Unit Structure',
}

export const multiFamilyClass = {
  shell: 'Shell',
  unit: 'Unit',
}

export const EMPTY = ''

export const FILTER_MENU_CONSTANTS = {
  ACCEPT: 'Accept',
  CANCEL: 'Cancel',
  CLEAR_ALL: 'Clear All',
  GRID_CONSTANTS: {
    BOOTSTRAP_COLUMNS: 12,
    COLUMNS: {
      COMPARE: {
        MULTI: 3,
        SINGLE: 4,
      },
      EXPORT: 4,
      FILTER: {
        SHELL: 3,
        SINGLE: 5,
        UNIT: 4,
      },
    },
    FULL_WIDTH_COLUMN_THRESHOLD: 2,
    MIN_COLUMN_SIZE: 2,
    SM_FULL_WIDTH: 12,
    SM_HALF_WIDTH: 6,
    XS_FULL_WIDTH: 12,
  },
  SELECT_ALL: 'Select All',
}

export const DOWNLOAD_PROGRESS_SIZE = 25
export const DOWNLOAD_PROGRESS_THICKNESS = 5

export const DETAILED_VIEW_PLAN_CONSTANTS = {
  ARCHITECTURE_AND_ENGINEERING_PLANS: 'Architecture and Engineering Plans',
  DOWNLOAD: 'Download',
  ELEVATIONS: 'Elevations',
  ELEVATIONS_PER_PAGE: 5,
  ERROR_MESSAGE: 'Error loading plan details:',
  EXPORT: 'Export',
  FLOOR_PLAN_PREVIEW_NOT_AVAILABLE: '- Floor Plan Preview Not Available',
  FLOOR_PLANS: 'Floor Plans',
  PLAN_DETAILS: 'Plan Details',
  PLAN_DETAILS_LABELS: {
    BASE_HOUSE_PRICE: 'Base House Price:',
    BEDROOMS: 'Bedrooms:',
    COMMUNITY_NAME: 'Community Name:',
    COMMUNITY_NUMBER: 'Community Number:',
    CONDITIONED_SPACE: 'Conditioned Space:',
    DEPTH: 'Depth:',
    DIVISION_NAME: 'Division:',
    FULL_BATHROOMS: 'Full Bathrooms:',
    GARAGE_SIZE: 'Garage Size:',
    GARAGE_SIZE_2: 'Garage Size 2:',
    GARAGES: 'Number of Cars/Garages:',
    GARAGES_2: 'Number of Cars/Garages 2:',
    HALF_BATHROOMS: 'Half Bathrooms:',
    PARENT_PLAN: 'Parent Plan:',
    REGION: 'Region:',
    WIDTH: 'Width:',
  },
  PLAN_NOT_FOUND: 'No plan details found for the requested plan.',
  SHARE: 'Share',
  SHELL_DETAILS_LABELS: {
    BUILDING_SQ_FT: 'Building Living Sq Ft:',
    DEPTH: 'Depth of the Building:',
    EXTERIOR_WALL_CONSTRUCTION: 'Exterior Wall Construction:',
    SHELL_TYPE: 'Shell Type:',
    STORIES: 'Stories:',
    UNITS: 'Units:',
    WIDTH: 'Width of the Building:',
  },
}

export const PROPAGATION_MODAL = {
  VALID_ATTRIBUTES_DISCLAIMER:
    '*Conditioned Space Sq Ft and Under Roof Sq ft attributes won’t be propagated since these are calculated values. Also, only changes relevant to the destination plans will be propagated.',
}

export const SORT = {
  GROUP_BY: 'Group By',
  ORDER: 'Order',
  SORT_BY: 'Sort By',
}

export const BULK_EDIT_PLAN_SELECTION_LIMIT = {
  MAX_VALUE: 10,
  MIN_VALUE: 2,
}
